import { useState, useEffect } from "react";
import { Item } from "types/common";
import { getTagData } from "api/tags";
import Gauge from "components/charts/Gauge/Gauge";
import { ReactComponent as ConnectorIcon } from "assets/circuit/connector.svg";
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import { getExpressionData } from "api/expression";

const CityGrid = () => {
  const [expressionsData, setExpressionsData] = useState<any>([]);

  const getSingleTag = async () => {
    const randomTagData = await getExpressionData([50, 51, 52, 53, 54, 55]);
    setExpressionsData(randomTagData.data);
  };

  useEffect(() => {
    getSingleTag();
  }, []);
  return (
    <div className="bg-black h-full w-full p-4 pt-0">
      {/* <h3 className="text-2xl mx-auto">City Grid</h3> */}
      <div className="h-full w-full flex flex-wrap items-end pt-2">
        <div className="h-[15%] w-full flex items-center justify-center">
          <h3 className="text-lg 2xl:text-2xl font-bold mb-2">City Grid</h3>
        </div>
        <div className="h-[85%] w-full flex">
          <div className="w-[34vw] h-full">
            {expressionsData.length > 0 &&
              <div className="flex h-[22vh] min-h-0 justify-start border-y-2 border-b-[6px] border-b-green border-t-blue relative p-2">
                <div className="relative bg-dark">
                  <Gauge
                    data={{ ...expressionsData[0], name: 'Power' }}
                    gaugeType={"regular"}
                  />
                  <span className="absolute w-full h-[8px] -bottom-4 bg-black -left-2 right-0" />
                </div>
                <div className="relative bg-dark">
                  <Gauge
                    data={{ ...expressionsData[1], name: 'Voltage' }}
                    gaugeType={"regular"}
                  />
                  <span className="absolute w-full h-[8px] -bottom-4 bg-black -left-2 right-0" />
                </div>
                <div className="relative bg-dark">
                  <Gauge
                    data={{ ...expressionsData[2], name: 'Current' }}
                    gaugeType={"regular"}
                  />
                  <span className="absolute h-[6px] bg-white -bottom-[14px] -left-2 2xl:-left-2.5 w-[55%] z-30" />
                  <div className="absolute z-20 w-full flex items-center justify-center pt-2 mt-[15px]">
                    <div className="relative bg-black">
                      <div className="w-4 h-[25px] bg-black relative z-20 text-green">
                        <ConnectorIcon />
                      </div>
                      <span className="absolute z-10 h-[7vh] w-[2px] bg-green -top-3 left-[7px]"></span>
                    </div>
                  </div>
                </div>
                <div className="absolute right-0 top-0 h-[75%] bg-green w-[2px]" />
                <div className="absolute bottom-4 -right-[7px] w-4">
                  <div className="relative bg-black">
                    <div className="w-4 h-[25px] bg-black relative z-20 text-green">
                      <ConnectorIcon />
                    </div>
                    <span className="absolute z-10 h-[6vh] w-[2px] bg-green -top-3 left-[7px]"></span>
                  </div>
                </div>
              </div>
            }
          </div>
          <div className="flex-1 h-full flex justify-between relative">
            <div className="w-[10vw] flex h-[22vh] min-h-0 justify-end pr-4 border-y-2 border-b-[6px] relative">
              <div className="absolute bottom-0 right-0 pr-1 text-lg">SS-A</div>
            </div>
            <div className="w-[10vw] flex h-[22vh] min-h-0 justify-end pr-4 border-y-2 border-b-[6px] relative">
              <div className="absolute bottom-0 left-0 pl-1 text-lg">SS-B</div>
            </div>
            <div className="absolute -top-10 2xl:-top-12 left-28">
              <FiArrowUp size={24} className="text-blue" />
              <p className="text-sm 2xl:text-md text-blue">SEC</p>
            </div>
            <div className="absolute  left-28">
              <p className="text-sm 2xl:text-md text-blue">NIC</p>
              <FiArrowDown size={24} className="text-blue" />
            </div>
            <span className="absolute right-1 top-1">{'SEC"B"'}</span>
            <span className="absolute left-1 top-1">{'SEC"C"'}</span>
            <span className="absolute -left-[2px] h-[40%] w-[2px] bg-green -top-10" />
            <span className="absolute -right-[2px] h-[40%] w-[2px] bg-white -top-10" />
            <div className="absolute w-full bg-blue h-[2px] -top-[0px]" />
            <div className="absolute w-full h-[19vh] top-0 left-0 right-0">
              <div className="h-full flex">
                {/* Left line */}
                <div className="w-[5vw] h-[75%] relative">
                  <svg className="absolute inset-0 w-full h-full text-white">
                    <line
                      x1="0"
                      y1="100%"
                      x2="100%"
                      y2="66%"
                      stroke="currentColor"
                      strokeWidth="2"
                      vectorEffect="non-scaling-stroke"
                    />
                  </svg>
                </div>

                {/* Center diamond with E */}
                <div className="flex-1 relative -mt-[2px]">
                  <div className="flex items-center justify-center h-full w-full">
                    <div className="relative flex items-center justify-center">
                      {/* Circle */}
                      <div className="absolute w-10 h-10 rotate-45 rounded-full border-4 z-10 border-white bg-black"></div>
                      {/* E centered */}
                      <span className="text-white text-2xl font-bold z-10">E</span>
                    </div>
                  </div>
                  <span className="absolute w-full left-0 right-0 top-1/2 h-[2px] bg-white"></span>
                </div>

                {/* Right line */}
                <div className="w-[5vw] h-[75%] relative">
                  <svg className="absolute inset-0 w-full h-full text-white">
                    <line
                      x1="0"
                      y1="66%"
                      x2="100%"
                      y2="100%"
                      stroke="currentColor"
                      strokeWidth="2"
                      vectorEffect="non-scaling-stroke"
                    />
                  </svg>
                </div>
              </div>
              <div className="relative h-[35%] mt-6 border-x-[2px] ">
                <div className="absolute top-0 -right-[9px] w-full flex items-center justify-end pt-2">
                  <div className="w-4 h-[25px] bg-black 2xl:mt-1">
                    <ConnectorIcon />
                  </div>
                </div>
                <div className="ml-40 mr-40 h-full relative border-x-[2px] border-b-[2px]">
                  <div className="absolute top-0 -right-[9px] w-full flex items-center justify-end pt-2">
                    <div className="w-4 h-[25px] bg-black 2xl:mt-1">
                      <ConnectorIcon />
                    </div>
                  </div>
                  <div className="absolute top-0 -left-[9px] w-full flex items-center justify-start pt-2">
                    <div className="w-4 h-[25px] bg-black 2xl:mt-1">
                      <ConnectorIcon />
                    </div>
                  </div>
                </div>
                <div className="absolute top-0 -left-[9px] w-full flex items-center justify-start pt-2">
                  <div className="w-4 h-[25px] bg-black 2xl:mt-1">
                    <ConnectorIcon />
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div className="w-[34vw] h-full">
            {expressionsData.length > 0 &&
              <div className="flex h-[22vh] p-2 min-h-0 justify-end border-y-2 border-b-[6px] border-t-blue relative">
                <div className="relative bg-dark">
                  <Gauge
                    data={{ ...expressionsData[3], name: 'Power' }}
                    gaugeType={"regular"}
                  />
                  <div className="absolute z-20 w-full flex items-center justify-center pt-2 mt-[15px]">
                    <div className="relative bg-black">
                      <div className="w-4 h-[25px] bg-black relative z-20">
                        <ConnectorIcon />
                      </div>
                      <span className="absolute z-10 h-[7vh] w-[2px] bg-white -top-3 left-[7px]"></span>
                    </div>
                  </div>
                </div>
                <div className="relative bg-dark">
                  <Gauge
                    data={{ ...expressionsData[5], name: 'Voltage' }}
                    gaugeType={"regular"}
                  />
                  <span className="absolute w-full h-[8px] -bottom-4 bg-black -right-2" />
                </div>
                <div className="relative bg-dark">
                  <Gauge
                    data={{ ...expressionsData[4], name: 'Current' }}
                    gaugeType={"regular"}
                  />
                  <span className="absolute w-full h-[8px] -bottom-4 bg-black -right-2" />
                </div>
                <div className="absolute left-0 top-0 h-[75%] bg-white w-[2px]" />
                <div className="absolute bottom-4 -left-[7px] w-4">
                  <div className="relative bg-black">
                    <div className="w-4 h-[25px] bg-black relative z-20">
                      <ConnectorIcon />
                    </div>
                    <span className="absolute z-10 h-[6vh] w-[2px] bg-white -top-3 left-[7px]"></span>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div >
  );
};

export default CityGrid;